import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import logoBimbo from "../../assets/img/Logo_Grupo_.png";
import logoCaja from "../../assets/img/caja de ahorro telefonistas.png";
import logoUnam from "../../assets/img/LOGO STRM.png";

const Clientes = () => {
  return (
    <section className="clientes-section">
      <Row>
        <Col md={9} className="mx-auto">
          <Container className="clientes-container text-center">
            <h2 className="clientes-title">Nuestros clientes</h2>
            <Row className="justify-content-center align-items-center gy-2">
              <Col xs={6} md={3} className="text-center">
                <img src={logoCaja} alt="Caja de ahorro" className="cliente-logo" />
              </Col>
              <Col xs={6} md={3} className="text-center">
                <img src={logoBimbo} alt="Grupo Bimbo" className="cliente-logo" />
              </Col>
              <Col xs={6} md={3} className="text-center">
                <img src={logoUnam} alt="UNAM" className="cliente-logo" />
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </section>
  );
};

export default Clientes;
